'use client';

import { useCallback } from 'react';

import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics';
import type { ContactType } from '@/lib/gtm/contactTracking';

export function useContactTracking() {
  const { sendContactEvent } = useGoogleAnalytics();

  const trackContact = useCallback(
    (contactType: ContactType) => {
      sendContactEvent(contactType);
    },
    [sendContactEvent]
  );

  const trackPhoneContact = useCallback(() => trackContact('phone'), [trackContact]);
  const trackEmailContact = useCallback(() => trackContact('email'), [trackContact]);

  return { trackContact, trackPhoneContact, trackEmailContact };
}
